<template>
	<div class="pagination-container">
		<el-pagination
			style="margin-left: auto; margin-right: 0"
			background
			layout="sizes, prev, pager, next"
			:page-sizes="page_sizes"
			:total="tot"
			:page-size="size"
			:current-page="offset/page_sizes + 1"
			@current-change="value => fetch(value)"
			@size-change="v => changeSize(v)"
			:pager-count="maxPages"
		>
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: "app-pagination",
	props: ["tot", "size", "offset"],
	data() {
		return {
			page_sizes: [1, 50, 75, 100, 200],
			maxPages: 5 //accettati solo valori dispari tra 5 e 21 altrimenti element ui da errore
		}
	},
	methods: {
		fetch: function (value) {
			this.$emit("fetch", value, this.size)
		},
		changeSize: function (size) {
			this.$emit("fetch", 1, size)
		}
	}
}
</script>
<style lang="css" scoped>
.pagination-container {
	position: fixed;
	bottom: 0;
	right: 0;
	padding: 10px;
	display: flex;
	margin-top: 10px;
	z-index: 5;
}

.total {
	display: flex;
	margin-top: auto;
	margin-bottom: auto;
}

.total span {
	margin-left: 5px;
	margin-right: 5px;
}
</style>
